
  module.exports =
  {
    search: require('./PackageDevelopments/search'),
    developments: require('./PackageDevelopments/developments'),
    edit: require('./PackageDevelopments/edit'),
  }